import React, { useEffect, useState } from "react";
import { Button, HStack } from "@chakra-ui/react";
import StepHeader from "../../../../../../../components/StepperHeader";
import "react-data-grid/lib/styles.css";

import { ArrowLeftIcon, ArrowRightIcon } from "@chakra-ui/icons";
import "./styles.css";
import SortableList, { SortableItem } from "react-easy-sort";
import { arrayMoveImmutable } from "array-move";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../../../redux/reducer/rootReducer";
import { ProblemRanking } from "./prioritize";
import { saveFormData } from "../../../../../../../redux/slice/formSlice";
interface Props {
  onNext: () => void;
  onPrev: () => void;
}

const Rank = (props: Props) => {
  const prioritizationData = useSelector(
    (state: RootState) => state.form.formData["5"]
  ) as ProblemRanking[];
  const [items, setItems] = useState([""]);

  const dispatch = useDispatch();

  useEffect(() => {
    console.log("Prioritization data: ", prioritizationData);
    const prioritizationArray = Object.values(prioritizationData);
    prioritizationArray.forEach((item) => {
      console.log("item: ", item);
    });

    let problemList = Array.isArray(prioritizationArray)
      ? prioritizationArray.sort((a, b) => {
          const rankA = typeof a.score === "number" ? a.score : Number(a.score);
          const rankB = typeof b.score === "number" ? b.score : Number(b.score);

          return rankB - rankA;
        })
      : [];

    let problemListArray = problemList.map((item) => item.name);

    setItems(problemListArray);
  }, []);

  const topThreshold = Math.ceil(items.length * 0.2);

  const onSortEnd = (oldIndex: number, newIndex: number) => {
    setItems((array) => arrayMoveImmutable(array, oldIndex, newIndex));
    //  setTopThreshold(Math.ceil(items.length * 0.2));
  };

  return (
    <>
      <StepHeader
        title="Select the top 20% of the problem list"
        description="Here are the ranked lists of problems/root causes based on the prioritization matrix. The top 20% of the problem list will be selected to be included in the next step.(Green)
Before proceeding to the next step, you have a chance to re-arrange them based your subject matter and profound knowledge. 
Press ‘Next‘ when you are done"
      />

      <SortableList
        onSortEnd={onSortEnd}
        className="list"
        draggedItemClassName="dragged"
      >
        {items.map((item, index) => (
          <SortableItem key={item}>
            <div className={`item ${index < topThreshold ? "top" : "lower"}`}>
              <span className="problem"> {item}</span>
            </div>
          </SortableItem>
        ))}
      </SortableList>

      <HStack
        flex={0.1}
        w="100%"
        mt={5}
        justifyContent="space-between"
        p={4}
        bg="gray.50"
      >
        <Button
          colorScheme="blue"
          variant="outline"
          leftIcon={<ArrowLeftIcon />}
          onClick={() => {
            if (props.onPrev) {
              props.onPrev();
            }
          }}
        >
          Previous
        </Button>
        <HStack>
          <Button colorScheme="blue" variant="outline">
            Save & Exit
          </Button>
          <Button
            colorScheme="blue"
            type="submit"
            w={"50%"}
            rightIcon={<ArrowRightIcon />}
            onClick={
              () => {
                // if (props.onNext ) {

                let data: any = items.filter(
                  (_, index) => index < topThreshold
                );

                let mappedData: { problem: string }[] = data.map(
                  (item: any, index: number) => {
                    return { problem: item };
                  }
                );
                dispatch(saveFormData({ step: "6", data: mappedData }));
                props.onNext && props.onNext();
              }
              // }
            }
          >
            Next
          </Button>
        </HStack>
      </HStack>
    </>
  );
};

export default Rank;
